import { render, staticRenderFns } from "./extendFieldSetDlg.vue?vue&type=template&id=ed773f88&"
import script from "./extendFieldSetDlg.vue?vue&type=script&lang=js&"
export * from "./extendFieldSetDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports